(function() {
    angular
        .module("app")
        .controller("SetArrowBoardDisplayController", SetArrowBoardDisplayController)

    SetArrowBoardDisplayController.$inject = [
        "$scope",
        "$uibModalInstance",
        "trackerID",
        "toBlankDisplay",
        "inRemoteMode",
        "onStart",
        "onSuccess",
        "onFailure",
        "trackersService"
    ]

    function SetArrowBoardDisplayController(
        $scope,
        $uibModalInstance,
        trackerID,
        toBlankDisplay,
        inRemoteMode,
        onStart,
        onSuccess,
        onFailure,
        trackersService
    ){
        "use strict"

        $scope.toBlankDisplay = toBlankDisplay
        $scope.inRemoteMode   = inRemoteMode

        $scope.setDisplay = function( ) {

            let displayState = 1

            if (toBlankDisplay) {
                displayState = 0
            }

            onStart()

            $uibModalInstance.close(
                trackersService.arrowBoardSetDisplayState(trackerID, displayState, onSuccess, onFailure)
            )
        }

       $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
